
    import Vue from "vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import {
        MedicalCertificateListItem,
        MedicalCertificatesClient,
        ValidityStatus,
        IMedicalCertificateListActions,
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import toasts from "@/components/Toasts";
    import userInfo from "@/features/shared/components/UserInfo";
    import FilterCheckbox from "@/components/FilterCheckbox.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import MedicalCertificatesTable from "@/features/personProfile/components/MedicalCertificatesTable.vue";

    class Filters {
        showApprovedAndNotExpired = true;
        showRejectedOrExpired = false;
        showUnchecked = true;
    }

    interface Props {
        medicalCertificates: MedicalCertificateListItem[];
        seafarerId: string;
        medicalCertificateListActions: IMedicalCertificateListActions;
    }

    @Component({
        components: {
            MedicalCertificatesTable,
            SectionPageHeading,
            FilterCheckbox
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<MedicalCertificateList>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new MedicalCertificatesClient().list(to.params.seafarerId),
                new MedicalCertificatesClient().availableListActions(to.params.seafarerId)
            ]).then(values => {
                props.medicalCertificates = values[0].medicalCertificates;
                props.medicalCertificateListActions = values[1];
                next();
            }).catch(e => next(e))
        }
    })
    export default class MedicalCertificateList extends Vue implements Props {
        @Prop({required: true})
        medicalCertificates!: MedicalCertificateListItem[];
        @Prop({required: true})
        seafarerId!: string;
        @Prop({ required: true })
        medicalCertificateListActions!: IMedicalCertificateListActions;

        filters = new Filters();
        userInfo = userInfo;

        CreateNewAddForm() {
            this.$router.push({name: "add-medical-certificate", params: {seafarerId: this.seafarerId}});
        }

        get filteredMedicalCertificates(): MedicalCertificateListItem[] {
            return this.medicalCertificates.filter(item =>
                this.filters.showApprovedAndNotExpired && item.status == ValidityStatus.Valid
                || this.filters.showRejectedOrExpired && item.status == ValidityStatus.Invalid
                || this.filters.showUnchecked && item.status == ValidityStatus.Unchecked);
        }
    }
